import image from "./image";
import notification from "./notification";
import support from "./support";

export default {
  methods: {
    ...image.methods,
    ...notification.methods,
    ...support.methods,
  },
}
